var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForbesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.674 17.972l-3.245.954C53.694 9.543 48.86 4.2 40.525 4.2h-10.88c-.604 6.235-.9 15.873-.604 26.274l7.252-.382c4.9 0 6.966-3.53 8.143-8.684h2.736V43.1h-2.736c-1.177-5.25-3.245-8.8-8.143-9.097l-7.252-.095c0 7.73.095 14.346.604 18.354.477 5.726 2.068 8.334 6.266 8.875l3.944.382V64H4.326v-2.48l2.958-.382c4.103-.573 5.8-3.15 6.266-8.875.795-9.352.986-29.328 0-40.43-.477-5.917-2.163-8.302-6.266-8.78l-2.958-.477V0H59.58z",
    fill: "#33629a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForbesIcon);
export default __webpack_public_path__ + "static/media/forbes-icon.6980f9008d020893cf6b3ce3baad0b48.svg";
export { ForwardRef as ReactComponent };